import ViewConfig from 'reducers/ViewConfigType';
const maybeLogError = (viewConfig: ViewConfig) => {
    return (...args: (Error | string)[]) => {
        if (viewConfig.user.roles.indexOf('ROLE_SUPER') !== -1 || process.env.NODE_ENV === 'development') {
            console.error(...args);
        }
    };
};
export default maybeLogError;
